var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EditUser',{directives:[{name:"show",rawName:"v-show",value:(_vm.user),expression:"user"}],attrs:{"user":_vm.user}})}
var staticRenderFns = []

export { render, staticRenderFns }